import { loadFileFromApi } from "actions/helpers/presigned_s3";
import DownloadFileTooltip from "components/downloadFileTooltip";
import type { ReportExecutionOut } from "kubb";
import { useState } from "react";

async function getArtifactsFileFromUrl(
  execution: ReportExecutionOut,
): Promise<void> {
  return loadFileFromApi(
    `/report/${execution.report_id}/artifacts?company_id=${execution.company_id}`,
  );
}

interface Props {
  execution: ReportExecutionOut;
}

function ReportExecutionArtifactsDownloadButton(props: Props) {
  const { execution } = props;

  const [loading, setLoading] = useState(false);
  const downloadable = execution.status === "COMPLETED";
  const failed = execution.status === "FAILED";

  const handleClick = async (): Promise<undefined> => {
    if (!loading) {
      setLoading(true);

      getArtifactsFileFromUrl(execution).finally(() => setLoading(false));
    }
    return;
  };

  return (
    <DownloadFileTooltip
      downloadable={downloadable}
      loading={loading}
      fileDescription={"Download report"}
      unavailableDescription={
        failed ? "This report failed" : "This report is calculating"
      }
      clickHandler={handleClick}
    />
  );
}

export default ReportExecutionArtifactsDownloadButton;
